module.exports = __webpack_public_path__ + "static/media/Dar-e-Arqam-Logo.4477c245.svg";